import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { IconButton, ListItem, ListItemText, Avatar, ListItemSecondaryAction, Box } from '@mui/material';
import useStyles from './DocumentList.styles';
import { Loading } from 'global/styles';
import { get, first, last } from 'global/lib/lodash';
import SystemIcon from 'global/components/SystemIcon';
import { getIcon } from '../definitions';
import { _size } from 'global/utils';
import { useShowChanges } from 'global/hooks/useShowChanges';
import clsx from 'clsx';

export default function DocumentListItem(props) {
  const { match, selected, sideFilters, getSideFilterKeys } = props;
  const { showChangesOn } = useShowChanges();

  const item = get(props, 'item.0');
  const { documentExistsInParentEdition, documentParentExistsInParentEdition, documentParentInParentEdition } = item;
  const id = get(item, 'document.classification.id');
  const doc = last(get(props, 'path', '').split('document/'));
  const isStyleUpdated = showChangesOn && documentParentExistsInParentEdition;
  const isStyleNew = showChangesOn && !isStyleUpdated && !documentExistsInParentEdition;

  const content = {
    ...item,
    title: get(item, 'document.name', Loading),
    realm: get(item, 'realm.name', Loading),
    createdDate: get(item, 'createdAt', Loading),
    auditor: get(item, 'user.email', Loading),
    classificationName: get(item, 'document.classification.system.name', 'No System Listed'),
  };

  const hasSelected = !!_size(selected);

  const classes = useStyles();
  const active = doc == id;
  const activeDocFilterExists = useMemo(
    () =>
      Object.keys(get(sideFilters, `doctype.data`, {})).reduce((acc, filt) => {
        if (get(sideFilters, `doctype.data.${filt}.value`) === true) {
          return true;
        }
        return acc;
      }, false),
    [sideFilters]
  );

  const RightIcons = (keyIndex) => {
    const icos = [{ search: 'checklist' }, { search: 'step_by_step' }, { search: 'sowId' }, { search: 'library_file' }, { search: 'library_video' }, { search: 'interactive_document' }].filter((ico) =>
      get(props, 'item', []).find((pi) => get(pi, 'documentableType') === ico.search)
    );

    return (
      <div className={classes.row}>
        {icos.map((ico) => {
          const isActive = get(sideFilters, `doctype.data.${ico.search}.value`);
          return (
            <div key={`${ico.search}-${keyIndex}`} className={clsx(classes.rowIcon, isActive ? classes.rowIconActive : activeDocFilterExists && classes.rowIconInactive)}>
              {getIcon(ico.search)}
            </div>
          );
        })}
      </div>
    );
  };

  const selectItem = (e) => {
    e.stopPropagation();
    e.preventDefault();
    props.onSelect({
      ...item,
      id,
    });
  };
  const to = () => {
    const activeTab = first(getSideFilterKeys());
    const obj = {
      ...(activeTab && { activeTab }),
      ...(showChangesOn && documentParentExistsInParentEdition && {
        documentParentId: get(documentParentInParentEdition, 'documentableId')
      }),
    };
    return `/library/${match.params.library}/document/${id}?${new URLSearchParams(obj).toString()}`;
  };

  const isSelected = get(selected, id);

  return (
    <ListItem
      component={props.onClick ? undefined : Link}
      to={to()}
      button
      onClick={!hasSelected ? (props.onClick ? (e) => props.onClick(content, e) : undefined) : selectItem}
      className={clsx(active ? classes.active : '')}
    >
      <IconButton onClick={selectItem} size="large">
        <Avatar className={!hasSelected ? classes.avatar : classes.avatarSelect}>
          <SystemIcon checked={!!isSelected} useCheckbox={hasSelected} systemId={get(content, 'document.classification.system.id')} />
        </Avatar>
      </IconButton>
      <Box className={isStyleUpdated ? classes.documentItemUpdated : isStyleNew ? classes.documentItemNew : undefined} minWidth="4px" height="40px" marginRight="8px" />
      <ListItemText className={content ? classes.noPad : ''} primary={content.title} secondary={content.classificationName} />
      <ListItemSecondaryAction>
        <RightIcons keyIndex={content.id} />
      </ListItemSecondaryAction>
    </ListItem>
  );
}
